<template>
  <div id="" class="">
      <el-form ref="form" :model="productData" label-width="80px" size="medium">
        <el-tabs v-model="activeName" type="card" >
          <el-tab-pane label="图片上传" name="first" >
            <div>
              <el-row>
                <el-col>
                  <el-form-item label="封面图片" label-width="110px" required>
                    <el-upload
                      drag
                      action="#"
                      :auto-upload="false"
                      ref="coverImageDom"
                      list-type="picture-card"
                      :limit="1"
                      :on-change="(file) => changeUpload(file,'coverImage')"
                      :on-remove="(file) => removeFile(file, 'coverImage')"
                      :file-list="coverImage">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col>
                  <el-form-item label="详情轮播图" label-width="110px" required>
                    <el-upload
                      drag
                      action="#"
                      :auto-upload="false"
                      ref="imagesDom"
                      multiple
                      list-type="picture-card"

                      :on-change="(file) => changeUpload(file,'images')"
                      :on-remove="(file) => removeFile(file, 'images')"
                      :file-list="images">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>


              <el-row>
                <el-col>
                  <el-form-item label="商品详情" label-width="110px" required>
                    <el-upload
                      drag
                      action="#"
                      :auto-upload="false"
                      ref="contentImageDom"
                      list-type="picture-card"
                      :limit="1"

                      :on-change="(file) => changeUpload(file,'contentImage')"
                      :on-remove="(file) => removeFile(file, 'contentImage')"
                      :file-list="contentImage">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="基础信息" name="second">
            <div>
              <el-row>
                <el-col :span="4">
                  <el-form-item label="商品目录" required>
                    <el-select
                      v-model="category"
                      placeholder="请选择">
                      <el-option
                        v-for="item in categoryOptions"
                        :key="item.value"
                        :label="item.value"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="6">
                  <el-form-item label="商品名称" required>
                    <el-input v-model="productData.name"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="6">
                  <el-form-item label="商品价格" required>
                    <el-input v-model="productData.price"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="库存信息" required>
                    <el-input v-model="productData.stock"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="6">
                  <el-form-item label="是否上架" required>
                    <el-radio-group v-model="productData.status">
                      <el-radio border label="on">是</el-radio>
                      <el-radio border label="off">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="8">
                  <el-form-item label="商品标签">
                    <div>
                      <el-tag
                        style="margin-right: 5px"
                        v-for="(tag,index) in productData.tags"
                        :key="tag"
                        closable
                        @close="closeTag(index)"
                        color="#000"
                        effect="dark">
                        {{tag}}
                      </el-tag>
                    </div>
                    <div  style="display: flex;margin-top: 5px">
                      <el-input style="margin-right: 10px" v-model="tag"></el-input>
                      <el-button @click="addTag" size="mini" style="width: 150px">添加标签</el-button>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="6">
                  <el-form-item label="商品介绍">
                    <el-input type="textarea" v-model="productData.description" rows="5"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

            </div>
          </el-tab-pane>


        </el-tabs>

        <el-dialog :visible.sync="ImageDialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>

      </el-form>
      <div  style="display: flex;justify-content: space-around">
        <el-button type="primary" @click="onSubmit" style="width: 150px;">{{type === '新增商品' ? '添 加' : '更 新'}}</el-button>
        <el-button v-if="type === '新增商品'" @click="reset" style="width: 150px">重 置</el-button>
      </div>
  </div>
</template>
<script>
export default {
  props:['type','dTitle','product','dialogVisible'],
  data() {
    return {
      activeName: 'first',

      coverImage: [], //封面图片
      //indexImage: [],
      images: [], //轮播图片
      contentImage: [], //内容图片

      dialogImageUrl: '',
      ImageDialogVisible: false,
      disabled: false,
      noInput: false,
      productData: {},
      category: '',
      categoryOptions: [],
      operationsList: [],

      cancel: true,
      oldRemoveList: [], //将要删除数组
      newAdditionList: [], //新增的图片数组
      uploadFileName: '',
      getToken: localStorage.getItem('token'),
      tags: [],
      tag: '',
      uploadCount: 0
    }
  },

  async mounted(){
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    await this.getCategories();
    this.resetProduct();
    if(!this.$util.isEmpty(this.product)){
      this.productData = this.product;
      this.category = this.product.category;

      this.coverImage = [{
        name: this.product.coverImage,
        url: this.$config.product_image_url + 'cover_image/' + this.product.coverImage
      }];
      this.contentImage = [{
        name: this.product.contentImage,
        url: this.$config.product_image_url + 'content_image/' + this.product.contentImage
      }];

      let images = [];
      this.product.images.forEach(image => {
        images.push({
          name: image,
          url: this.$config.product_image_url + 'images/' + image
        });
      })
      this.images = images;
    }
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload); // 移除监听防内存泄漏
  },

  beforeRouteLeave(to, from, next){
    console.log('leave ');
    this.reset();
  },

  watch:{
    product(val){
      if(!this.$util.isEmpty(val)){
        this.productData = val;
        this.category = val.category;

        this.coverImage = [{
          name: val.coverImage,
          url: this.$config.product_image_url + 'cover_image/' + val.coverImage
        }];
        this.contentImage = [{
          name: val.contentImage,
          url: this.$config.product_image_url + 'content_image/' + val.contentImage
        }];

        let images = [];
        val.images.forEach(image => {
          images.push({
            name: image,
            url: this.$config.product_image_url + 'images/' + image
          });
        })
        this.images = images;
      }
    }
  },

  methods:{

    //点击上传按钮
    changeUpload(file,type){
      switch (type){
        case 'coverImage':
          this.coverImage.push({
            file: file.raw,
            url: file.url
          })
          break;
        case 'images':
          this.images.push({
            file: file.raw,
            url: file.url
          })
          break;
        case 'contentImage':
          this.contentImage.push({
            file: file.raw,
            url: file.url
          })
          break;
      }
    },

    //移除已上传图片
    removeFile(file,type){
      switch (type){
        case 'coverImage':
          this.coverImage = [];
          break;
        case 'images':
          let delIndex = -1;
          for(const [index,image] of this.images.entries()){
            if(image.uid && image.uid === file.uid){
              delIndex = index;
              break;
            }
          }
          if(delIndex !== -1)
            this.images.splice(delIndex,1);

          break;
        case 'contentImage':
          this.contentImage = [];
          break;
      }
      if(file.url.includes('https')){
        const urlList = file.url.split('/');
        this.oldRemoveList.push(`${urlList[3]}/${urlList[4]}/${urlList[5]}`)
      }
    },

    //文件上传至服务器(适应编辑上传)
    async uploadToServer(uploadList,type){
      const formData = new FormData();

      uploadList.forEach(item => {
        // 如果是本地文件需要上传
        if(item.file) formData.append('uploadFiles',item.file)
      });

      const uploadResponse = await this.$request.file_upload(type,formData);
      const uploadedUrls = uploadResponse.data;
      //console.log(uploadedUrls);
      // 3. 更新轮播图项的URL为服务器URL
      let urlIndex = 0;
      return uploadList.map(item => {
        if (item.file)
          return uploadedUrls[urlIndex++].filename
        else {
          const i = item.url.split('/');
          return i[i.length - 1]
        }
      })
    },

    //重置商品信息，将信息设为空，此时若图片信息不为空，则需要执行删除操作
    reset(){
      this.resetProduct();
    },

    //将本地商品信息清空
    resetProduct(){
      this.productData = {
        _id: '',
        name: '',
        price: '',
        stock: '',
        status: '',
        tags: [],
        description: '',
      }
      this.category = "";
      this.coverImage = [];
      this.images = [];
      this.contentImage = [];

      //编辑时将会用到
      this.oldRemoveList = [];
      this.newAdditionList = [];
    },

    //离开时执行
    beforeClose(){
      this.reset();
      this.$emit('state-change',{isCancel: this.cancel});
    },

    //设置上传框位置
    init(){
      if(this.$refs['imagesDom'])
        this.$refs['imagesDom'].$children[1].$el.className = 'el-upload'
      if(this.$refs['coverImageDom'])
        this.$refs['coverImageDom'].$children[1].$el.className = 'el-upload'
      if(this.$refs['contentImageDom'])
        this.$refs['contentImageDom'].$children[1].$el.className = 'el-upload'
    },

    fileListToStr(list){
      if(list.length === 0) return '';
      let result = [];
      list.forEach(item => {
        result.push(item.url);
      })
      return result.join(',');
    },

    //保存，点击保存上传成功后将所有数据情况，确保离开页面时执行删除函数不会误删
    async onSubmit() {
      this.uploading = this.$loading({
        lock: true,
        text: '拼命加载中...',
      });

      if(this.$util.isEmpty(this.productData.name) || this.$util.isEmpty(this.productData.price)
        || this.$util.isEmpty(this.productData.stock) || this.$util.isEmpty(this.productData.status)){
        this.$message("请输入必要参数！");
        return;
      }

      const coverImage = await this.uploadToServer(this.coverImage,'coverImage');
      const images = await this.uploadToServer(this.images, 'images');
      const contentImage = await this.uploadToServer(this.contentImage, 'contentImage');

      let productInfo = {
        category: this.category,
        name: this.productData.name,
        price: this.productData.price,
        stock: this.productData.stock,
        status: this.productData.status,
        tags: this.productData.tags.join(','),
        description: this.productData.description,
        coverImage: coverImage[0],
        images,
        contentImage: contentImage[0],
      }
      let productId = null;
      if(this.type === '编辑商品'){
        productId = this.productData._id;
      }

      try{
        if(productId) productInfo.id = productId
        const result = await this.$request.set_message('products',productInfo)
        if(result.code === 0){
          this.$message(result.message);

          //编辑时需要将旧图片彻底删除
          if(this.type === '编辑商品'){
            if(this.oldRemoveList.length > 0) await this.$request.drop_files(this.oldRemoveList);
            this.cancel = false;
            this.beforeClose();
          }else{
            this.resetProduct();
          }


        }else{
          this.$message(result['errMsg']);
        }
      } catch(e) {
        this.$message(e);
      } finally {
        this.uploading.close();
      }
    },

    addTag(){
      this.productData.tags.push(this.tag);
      this.tag = "";
    },

    closeTag(index){
      this.productData.tags.splice(index,1);
    },

    async getCategories(){
      const categories = await this.$request.get_message('categories',{});
      const categoryOptions = []
      if(categories.code === 0){
        categories.data.forEach(category => {
          categoryOptions.push({
            value: category.categoryName
          })
        })
        this.categoryOptions = categoryOptions;
      }else{
        this.$message(categories['errMsg'])
      }
    },

    handleBeforeUnload(event) {
      console.log('leave')
    }

  },

}
</script>

<style>
.no-input{
  border: 1px solid red;
}
.el-radio{
  margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/instrument/AccountComponent.vue